/** "POTENTIAL_CUSTOMER" -> "Potential Customer" */
export function formatEntityTypeLabel(type: string): string {
  return type
    .split('_')
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(' ');
}
